export default {
  state: {
    checkoutStep: 1,
    checkout: null,
    tmpOrder: null,
    couponsEnabled: false,
    confirmStreetState: false,
  },
  getters: {
    CHECKOUT: state => {
      return state.checkout;
    },
    CHECKOUT_STEP: state => {
      return state.checkoutStep;
    },
    TMP_ORDER: state => {
      return state.tmpOrder;
    },
    COUPONS_ENABLED: state => {
      return state.couponsEnabled || !!state.checkout.coupon;
    },
    CONFIRM_STREET_STATE: state => {
      return state.confirmStreetState;
    },
  },
  mutations: {
    SET_CHECKOUT: (state, payload) => {
      state.checkout = payload;
    },
    SET_CHECKOUT_STEP: (state, payload) => {
      state.checkoutStep = payload;
    },
    SET_TMP_ORDER: (state, payload) => {
      state.tmpOrder = payload;
    },
    SET_COUPONS_ENABLED: (state, payload) => {
      state.couponsEnabled = payload;
    },
    SET_CONFIRM_STREET_STATE: (state, payload) => {
      state.confirmStreetState = payload;
    },
  },
  actions: {
    INIT_CHECKOUT: (context) => {
      context.commit('SET_CHECKOUT', {
        authType: null,
        orderAsGuest: false,
        personalData: null,
        shippingOption: null,
        paymentOption: null,
        coupon: null,
        total: null,
      });
    },
    SET_CHECKOUT_STEP: (context, step) => {
      context.commit('SET_CHECKOUT_STEP', step);
    },
    SET_CHECKOUT: (context, checkout) => {
      context.commit('SET_CHECKOUT', checkout);
    },
    SET_TMP_ORDER: (context, tmpOrder) => {
      context.commit('SET_TMP_ORDER', tmpOrder);
    },
    SET_COUPONS_ENABLED: (context, couponsEnabled) => {
      context.commit('SET_COUPONS_ENABLED', couponsEnabled);
    },
    CLEAR_CHECKOUT: (context) => {
      context.dispatch('INIT_CHECKOUT');
    },
    CLEAR_TMP_ORDER: (context) => {
      context.dispatch('SET_TMP_ORDER', null);
    },
  },
};